function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF",
  offset: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-157 -474)",
  fill: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 447)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(150 20)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.5 7.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.5 11.25c1.2375 0 2.25 1.0125 2.25 2.25v9c0 1.2375-1.0125 2.25-2.25 2.25s-2.25-1.0125-2.25-2.25v-9c0-1.2375 1.0125-2.25 2.25-2.25zm-0.0225-11.25c-12.42 0-22.478 10.08-22.478 22.5s10.058 22.5 22.478 22.5c12.442 0 22.522-10.08 22.522-22.5s-10.08-22.5-22.522-22.5zm0.0225 40.5c-9.945 0-18-8.055-18-18s8.055-18 18-18 18 8.055 18 18-8.055 18-18 18zm0-6.75c-1.2426 0-2.25-1.0074-2.25-2.25s1.0074-2.25 2.25-2.25 2.25 1.0074 2.25 2.25-1.0074 2.25-2.25 2.25z"
}))))));

function SvgErrorOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0AA366DF-06D1-45F6-B024-B9F6A95B8DA1@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error-outline.eafe699f.svg";
export { ForwardRef as ReactComponent };